module.exports = __webpack_public_path__ + "img/20190523191525微信截图_20190523191903.0fcb533d.png";